module.exports = __webpack_public_path__ + "static/media/logoTerraLAB.f23b08e3.svg";